import { useWindowDimension } from "capitalrx-components-2.0";

import Video from "@/static/videos/video-hero-bg.mp4";
import HeroImage from "@/static/images/advantage-hero-mobile-image-min.jpg";

import styles from "./VideoBackground.module.scss";

const VideoBackground = (): JSX.Element => {
  const displayImage = useWindowDimension(768);

  return (
    <>
      {!displayImage ? (
        <video
          autoPlay
          loop
          muted
          src={Video}
          className={styles.VideoBackgroundDesktop}
          aria-hidden="true"
          data-testid="advantage-header-video"
        />
      ) : null}
      <img alt="" src={HeroImage} className={styles.VideoBackgroundMobile} aria-hidden="true" data-testid="advantage-header-image" />
    </>
  );
};

export default VideoBackground;
